export const NO_GROUP_KEY = '__no_group__';
